export const zodiac = [
  {
    name: 'aquarius',
    dates: 'Jan 21 - Feb 19',
  },
  {
    name: 'aries',
    dates: 'Mar 21 - Apr 19',
  },
  {
    name: 'cancer',
    dates: 'Jun 21 - Jul 22',
  },
  {
    name: 'capricorn',
    dates: 'Dec 22 - Feb 19',
  },
  {
    name: 'gemini',
    dates: 'May 21 - Jun 20',
  },
  {
    name: 'leo',
    dates: 'Jul 23 - Aug 22',
  },
  {
    name: 'libra',
    dates: 'Sept 23 - Oct 22',
  },
  {
    name: 'pisces',
    dates: 'Fab 19 - Mar 20',
  },
  {
    name: 'sagittarius',
    dates: 'Nov 22 - Dec 21',
  },
  {
    name: 'scorpio',
    dates: 'Oct 23 - Nov 21',
  },
  {
    name: 'taurus',
    dates: 'Apr 20 - May 20',
  },
  {
    name: 'virgo',
    dates: 'Aug 23 - Sep 22',
  },
]
